/* Flowbam · Wishlist 引擎（2026-06-25）—— 游客 localStorage 收藏。
   做四件事：存/取(localStorage) · 同步♡状态 · 同步头部角标 · 渲染收藏抽屉；加收藏时发 GA4 add_to_wishlist 事件。
   局限：只在本机本浏览器；后台看不到谁存了什么（聚合数据走 GA4 事件）。 */
(function () {
  var KEY = 'flowbam_wishlist_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function ids() { return read().map(function (x) { return String(x.id); }); }
  function has(id) { return ids().indexOf(String(id)) >= 0; }

  function money(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return '';
    return '$' + (n / 100).toFixed(2);
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function itemFromEl(el) {
    return {
      id: el.getAttribute('data-wish-id'),
      title: el.getAttribute('data-wish-title') || '',
      price: el.getAttribute('data-wish-price') || '',
      image: el.getAttribute('data-wish-image') || '',
      url: el.getAttribute('data-wish-url') || ''
    };
  }

  function fireGA(item) {
    try {
      var val = (parseInt(item.price, 10) || 0) / 100;
      var payload = { currency: 'USD', value: val, items: [{ item_id: String(item.id), item_name: item.title, price: val }] };
      if (window.gtag) window.gtag('event', 'add_to_wishlist', payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'add_to_wishlist' }, payload));
    } catch (e) {}
  }

  function toggle(item) {
    if (!item || !item.id) return;
    var list = read(), id = String(item.id), idx = -1;
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === id) { idx = i; break; } }
    var added;
    if (idx >= 0) { list.splice(idx, 1); added = false; }
    else { list.unshift(item); added = true; }
    write(list); syncHearts(); syncCount(); renderDrawer();
    if (added) fireGA(item);
  }

  function remove(id) {
    write(read().filter(function (x) { return String(x.id) !== String(id); }));
    syncHearts(); syncCount(); renderDrawer();
  }

  function syncHearts() {
    var on = ids();
    document.querySelectorAll('[data-wish]').forEach(function (el) {
      var saved = on.indexOf(String(el.getAttribute('data-wish-id'))) >= 0;
      el.classList.toggle('is-saved', saved);
      el.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function syncCount() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  }

  function renderDrawer() {
    var box = document.querySelector('[data-wish-items]');
    if (!box) return;
    var list = read(), empty = document.querySelector('[data-wish-empty]');
    if (!list.length) { box.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    box.innerHTML = list.map(function (x) {
      var img = x.image ? '<img src="' + esc(x.image) + '" alt="" loading="lazy">' : '';
      return '<div class="flowbam-wish__li">'
        + '<a href="' + esc(x.url) + '" class="flowbam-wish__thumb">' + img + '</a>'
        + '<div class="flowbam-wish__meta">'
        + '<a href="' + esc(x.url) + '" class="flowbam-wish__nm">' + esc(x.title) + '</a>'
        + '<div class="flowbam-wish__pr">' + money(x.price) + '</div></div>'
        + '<button type="button" class="flowbam-wish__rm" data-wish-remove="' + esc(x.id) + '" aria-label="Remove">&times;</button>'
        + '</div>';
    }).join('');
  }

  function setDrawer(open) {
    var d = document.querySelector('[data-wish-drawer]');
    if (!d) return;
    if (open) renderDrawer();
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-wish]');
    if (heart) { e.preventDefault(); e.stopPropagation(); toggle(itemFromEl(heart)); return; }
    if (e.target.closest('[data-wish-open]')) { e.preventDefault(); setDrawer(true); return; }
    if (e.target.closest('[data-wish-close]')) { setDrawer(false); return; }
    var rm = e.target.closest('[data-wish-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-wish-remove')); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('[data-wish]')) {
      e.preventDefault(); toggle(itemFromEl(e.target.closest('[data-wish]')));
    }
  });

  function init() { syncHearts(); syncCount(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.FlowbamWishlist = { read: read, toggle: toggle, remove: remove, has: has };
})();
